import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/dashboard' },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/dashboard')
  },
  {
    path: '/productDisplay',
    name: 'productDisplay',
    component: () => import('../views/productDisplay')
  },
  {
    path: '/solution/electric',
    name: '电力行业解决方案',
    component: () => import('../views/solution/electric.vue'),
  },
  {
    path: '/solution/telecom',
    name: '电信行业解决方案',
    component: () => import('../views/solution/telecom.vue'),
  },
  {
    path: '/solution/pivotal',
    name: '关键制造行业解决方案',
    component: () => import('../views/solution/pivotal.vue'),
  },
  {
    path: '/solution/campus',
    name: '智慧校园信息安全解决方案',
    component: () => import('../views/solution/campus.vue'),
  },
  {
    path: '/we',
    name: 'we',
    component: () => import('../views/we')
  },
  //产品
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/productInfo/index.vue')
  },
  //产品详情
  {
    path: '/products_info',
    name: 'products_info',
    component: () => import('../views/productInfo/info.vue')
  },
  //联系我们
  {
    path: '/lxwm',
    name: 'lxwm',
    component: () => import('../views/gywm/lxwm.vue')
  },
  //职位招聘
  {
    path: '/zwzp',
    name: 'zwzp',
    component: () => import('../views/gywm/zwzp.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
});
export default router
